import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  private readonly isFullUrl = (url: string): boolean => /^(http|https):\/\//.test(url);
  private readonly isLocalAssets = (url: string): boolean => /\/public\//.test(url);
  private readonly isI18nFile = (url: string): boolean => /(^|\/)i18n\/.*\.json$/.test(url);
  private readonly isVersionFile = (url: string): boolean => /(^|\/)version\.json(\?|$)/.test(url);

  public buildApiUrl(path: string): string {
    if (this.isFullUrl(path) || this.isLocalAssets(path) || this.isI18nFile(path) || this.isVersionFile(path)) {
      return path;
    }

    const baseUrl = environment.apiUrl;

    if (!baseUrl) {
      return path;
    }

    const cleanPath = path.replace(/^\/+/, '');
    const cleanBaseUrl = baseUrl.replace(/\/+$/, '');

    return `${cleanBaseUrl}/${cleanPath}`;
  }
}
